// Copyright (c) 2022 by Move Closer

import { DrawerLayout } from '../../../../dsl/molecules/Drawer/Drawer.config'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const drawerConfig = {
  /**
   * Determines whether drawer should be closable with outside click.
   */
  closeOnClickOutside: false,

  /**
   * Determines whether drawer has a backdrop.
   */
  hasBackdrop: true,

  /**
   * Determines whether drawer has header.
   */
  hasHeader: true,

  /**
   * Determines drawer layout
   */
  layout: DrawerLayout.Full
}
